import { Injectable } from '@angular/core';
import { UploadFile } from '@common';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class UploadService {
  container = environment.nhn.objectStorageContainer;

  async upload(file: File): Promise<UploadFile> {
    try {
      const formData = new FormData();
      formData.append('files', file); // `file`은 File 객체

      const response = await fetch(`${environment.baseUrl}/api/storage/${environment.nhn.objectStorageContainer}`, {
        method: 'POST',
        body: formData, // FormData 객체 전달
        headers: {
          // Content-Type은 명시적으로 설정하지 않습니다. fetch가 자동으로 설정
        },
      });

      const res = await response.json();
      return {
        url: res[0].url,
        filename: res[0].name,
      };
    } catch (error) {
      throw new Error('Failed to upload file');
    }
  }

  async delete(url: string): Promise<void> {
    const encodedUrl = encodeURIComponent(url);
    await fetch(`${environment.baseUrl}/api/storage/${encodedUrl}`, {
      method: 'DELETE',
    });

    return;
  }
}
